import { Button, IconType } from '@msaf/core-react'

type ZoomControlOption = {
  id: string
  iconType: IconType
  iconAriaLabel: string
  zoomAction: () => void
  noop: (event: React.SyntheticEvent) => void
}

type CustomZoomControlProps = {
  zoomControlOptions: ZoomControlOption[]
}

export default function CustomZoomControl({ zoomControlOptions }: CustomZoomControlProps) {
  return (
    <div className='c-map-screen__zoom-controls'>
      {zoomControlOptions.map(({ id, iconType, iconAriaLabel, zoomAction, noop }: ZoomControlOption) => (
        <Button
          key={id}
          iconAriaLabel={iconAriaLabel}
          icon={iconType}
          onClick={zoomAction}
          onDoubleClick={noop}
          buttonStyle='tertiary'
        />
      ))}
    </div>
  )
}
